import React, { FC, useRef, useEffect } from 'react';
import { Messages } from '@marriott/mi-ui-library';

import { usePrivacyRightsStore } from '../../store';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';
import { PrivacyRightsAlertComponentType } from './PrivacyRightsWrapper.types';

export const PrivacyRightsAlertComponent: FC<PrivacyRightsAlertComponentType> = ({
  profileUpdateAlertMessage,
  profileUpdateAuthAlertMessage,
  profileNotFoundMessage,
  apiErrorMessage,
  authInEligibleAlertMessage,
}) => {
  const alertRef = useRef<HTMLDivElement>(null);

  const { showAlertComponent, alertType } = usePrivacyRightsStore(state => state.alertComponentConfig);

  useEffect(() => {
    if (showAlertComponent && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  const alertConfig = {
    apiError: { messageType: 'error-sev1', messageText: apiErrorMessage },
    profileNotFound: { messageType: 'error-sev1', messageText: profileNotFoundMessage },
    authIneligible: { messageType: 'warning', messageText: authInEligibleAlertMessage },
    profileUpdated: { messageType: 'success', messageText: profileUpdateAlertMessage },
    authProfileUpdated: { messageType: 'success', messageText: profileUpdateAuthAlertMessage },
  };

  const alertData = alertType ? alertConfig[alertType] : null;

  return showAlertComponent && alertData ? (
    <div ref={alertRef} data-testid="privacyRights-Alert-Msg">
      <Messages messageType={alertData.messageType} className="mb-5">
        <LegalTextWithLink
          className="alert"
          descriptionText={alertData.messageText}
          testId="legal-privacy-alert-message"
          innerChildClassName="mt-0 mb-0"
        />
      </Messages>
    </div>
  ) : null;
};
